<template>
	<div class="chat container">
		<h2 class="center teal-text">Ninja Chat</h2>
		<div class="card">
			<div class="card-content">
				<ul ref="messages" class="messages">
					<li v-for="message in messages" :key="message.id">
						<span class="teal-text">{{ message.name }}</span>
						<span class="grey-text text-darken-3">{{ message.content }}</span>
						<span class="grey-text time">{{ message.timestamp }}</span>
					</li>
				</ul>
			</div>
			<div class="card-action">
				<NewMessage :name="name" />
			</div>
		</div>
	</div>
</template>

<script>
import NewMessage from '@/components/NewMessage'
import db from '@/firebase/init'
import moment from 'moment'

export default {
	name: 'Chat',
	props: ['name'],
	components: { NewMessage },
	data() {
		return {
			messages: [],
		}
	},
	created() {
		let ref = db.collection('message').orderBy('timestamp')

		ref.onSnapshot( snapshot => {
			let addedChanges = snapshot.docChanges().filter(change => change.type == 'added')
			let addedMsgs = addedChanges.map(change => {
				let doc = change.doc
				return {
					id: doc.id,
					name: doc.data().name,
					content: doc.data().content,
					timestamp: moment(doc.data().timestamp).format('lll'),
				}
			})
			console.log(addedMsgs)
			this.messages = this.messages.concat(addedMsgs)
		})
	},
	updated() {
		this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
	}
}
</script>

<style>
.chat h2 {
	font-size: 2.6em;
	margin-bottom: 40px;
}

.chat span {
	font-size: 1.4em;
}

.chat .time {
	margin-bottom: 2px;
	font-size: 0.8em;
	display: block;
}

.messages {
	max-height: 300px;
	overflow: auto;
}

.messages::-webkit-scrollbar {
    width: 10px;
}

.messages::-webkit-scrollbar-track {
    background: #f1f1f1; 
}
 
.messages::-webkit-scrollbar-thumb {
    background: #888; 
}

.messages::-webkit-scrollbar-thumb:hover {
    background: #555; 
}
</style>


// WEBPACK FOOTER //
// src/components/Chat.vue